import "./styles.scss";

import React from "react";

import { ROLE } from "../../../constants/phase";
import AdminHeader from "./AdminHeader/AdminHeader";
import OpsHeader from "./OpsHeader/OpsHeader";
import SuperAdminHeader from "./SuperAdminHeader/SuperAdminHeader";

const Header = (props) => {
  let Header;

  switch (props.role) {
    case ROLE.SUPER_ADMIN:
      Header = SuperAdminHeader;
      break;

    case ROLE.ADMIN:
    case ROLE.CD_ADMIN:
    case ROLE.CD_TEAM_LEAD:
    case ROLE.CD_TEAM_MEMBER:
      Header = AdminHeader;
      break;

    case ROLE.USER:
      Header = AdminHeader;
      break;

    case ROLE.REVIEWER:
      Header = AdminHeader;
      break;

    default:
      Header = OpsHeader;
      break;
  }
  return <Header {...props} />;
};
export default Header;
